export default "/images/music.svg?f3d2147c0730c4c4327ae08079c46423";